import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiCheckbox from "@mui/material/Checkbox";
import FormControlLabel from "../FormControlLabel";
import classNames from "classnames";
import ErrorHandlingFormHelperText from "../ErrorHandlingFormHelperText";

/**
 * @deprecated Use CheckboxProps instead
 */

export const Checkbox = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    id,
    className,
    disabled,
    label,
    onChange,
    helperText,
    popoverText,
    customHelperIcon,
    color = "secondary",
    ...otherProps
  } = props;
  const handleOnChange = e => {
    const checked = e.target.checked;
    onChange && onChange(e, checked);
  };
  const renderedCheckbox = /*#__PURE__*/React.createElement(MuiCheckbox, _extends({
    ref: ref,
    id: id,
    onChange: handleOnChange,
    disabled: disabled,
    className: classNames("prmbl-checkbox", className),
    color: color
  }, otherProps));
  return /*#__PURE__*/React.createElement(React.Fragment, null, label ? /*#__PURE__*/React.createElement(FormControlLabel, {
    id: id ? `${id}-label` : undefined,
    control: renderedCheckbox,
    label: label
  }) : renderedCheckbox, /*#__PURE__*/React.createElement(ErrorHandlingFormHelperText, {
    id: id,
    disabled: disabled,
    helperText: helperText,
    popoverText: popoverText,
    customHelperIcon: customHelperIcon
  }));
});
Checkbox.displayName = "Checkbox";
export default Checkbox;